import React, { useRef } from 'react'
import { Input, Icon } from 'antd'
import styles from './index.module.less'

interface SearchBarProps {
	value: string
	clearHandler(): void
	searchTextChangeHandler(e: React.ChangeEvent<HTMLInputElement>): void
	formSubmitHandler(e: React.FormEvent<HTMLFormElement>): void
}

export default function SearchBar({ value, clearHandler, searchTextChangeHandler, formSubmitHandler }: SearchBarProps) {
	const inputRef = useRef<Input>()

	return (
		<form className={styles.searchBarWrapper} onSubmit={formSubmitHandler}>
			<Icon onClick={() => inputRef.current.focus()} className={styles.searchBarIcon} type='search' />
			<Input
				ref={ref => (inputRef.current = ref)}
				value={value}
				onChange={searchTextChangeHandler}
				type='text'
				className={styles.searchBarInput}
				placeholder='Search all'
			/>
			<Icon onClick={clearHandler} className={styles.searchBarClearIcon} type='close' />
		</form>
	)
}
